import React, { ReactNode } from 'react';
import { Link } from "react-router-dom";
import HeaderUserPane from '@/components/Helpers/HeaderUserPane';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import cx from 'classnames';

export type headerTypes = "primary" | "secondary";

export interface GlobalHeaderProps {
  headerType?: headerTypes;
  title?: string;
  link?: ReactNode;
  showUserPane?: boolean;
  showDateTime?: boolean;
}

export const GlobalHeader: React.FC<GlobalHeaderProps> = ({
  headerType = "secondary",
  title = "",
  link,
  showUserPane = true,
  showDateTime = false
}) => {
  const { t } = useTranslation(['navigation']);
  const DEFAULT_LINK = <Link className="page-header-back-link" to="/dashboard">{t('BackToDashboard')}</Link>;
  const headerClassNames = cx({
    'page-header': true,
    'primary-header': headerType === "primary",
    'flex-wrap': true,
  });
  return (
    <header className={headerClassNames}>
      <div className="page-masthead">
        { headerType === "secondary" && (link ? link : DEFAULT_LINK) }
        <h1>{ title }</h1>
        { showDateTime && (
            <span className="header-date-time">
              {moment().format("LT")} {moment().format("ll")}
            </span>
          )
        }
      </div>
      {showUserPane && <HeaderUserPane />}
    </header>
  );
};